import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/denntenna.github.io/denntenna.github.io/src/components/default-mdx-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Design Justice: Community-Led Practices to Build the Worlds We Need`}</h1>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "520px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/bbcc4e51bf74e2d318218780e3b69017/ddb38/cover_design_justice.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "150%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAQACBf/EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAAB4jhuiKRcpmo//8QAGhAAAwADAQAAAAAAAAAAAAAAAAERAhASIP/aAAgBAQABBQJY1cjUKPSL5//EABURAQEAAAAAAAAAAAAAAAAAACAh/9oACAEDAQE/AYP/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAWEAEBAQAAAAAAAAAAAAAAAAAQMSD/2gAIAQEABj8CxWMP/8QAGxAAAwACAwAAAAAAAAAAAAAAAAEREFEhQXH/2gAIAQEAAT8h5AnZRChpJVG2xp1ScF5SrTH/2gAMAwEAAgADAAAAEFPUPP/EABYRAAMAAAAAAAAAAAAAAAAAAAAQIf/aAAgBAwEBPxAR/wD/xAAWEQADAAAAAAAAAAAAAAAAAAABESD/2gAIAQIBAT8QCj//xAAhEAACAgAFBQAAAAAAAAAAAAABEQAhEDFhcdFBUaHh8f/aAAgBAQABPxC4FG0KuAnuIe0CEwXnK0wtoQiAYM1lpEj6BZQLsG7zQeOMCANhuh+zzh//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Book Cover",
            "title": "Book Cover",
            "src": "/static/bbcc4e51bf74e2d318218780e3b69017/ddb38/cover_design_justice.jpg",
            "srcSet": ["/static/bbcc4e51bf74e2d318218780e3b69017/f93b5/cover_design_justice.jpg 300w", "/static/bbcc4e51bf74e2d318218780e3b69017/ddb38/cover_design_justice.jpg 520w"],
            "sizes": "(max-width: 520px) 100vw, 520px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`The book is well divided into 5 concrete chapters, each taking on a distinct aspect of a new justice led approach to designing solution.`}</p>
    <h2>{`Chapter 1 : Design Values`}</h2>
    <p>{`Matrix of Oppression`}</p>
    <h2>{`Chapter 2 : Design Practices`}</h2>
    <p>{`What you do as "design" need to challenge systemic issues and not just aspire for reductive frames like "diverse teams"`}</p>
    <p>{`An important question to consider is - who do you build for? A priviledged person's wants or an under priviledged person's needs.`}</p>
    <p>{`Its important to explicitly defind your user, their demographics, identity etc so as to not default to designing for the "unmarked" user.`}</p>
    <p>{`Ensure that you're not just designing for the demographic with the paying capacity.`}</p>
    <p>{`Solutions :`}</p>
    <ul>
      <li parentName="ul">{`Robust engagement with marginalized users and communities. Identify that they already have solutions and ideas on how to solve the problmes they face.`}</li>
      <li parentName="ul">{`Non extractive design`}</li>
      <li parentName="ul">{`Involve community members in the entire process and not just to generate ideas.`}</li>
      <li parentName="ul">{`distribute benefits of the design process equitably amongst the community and not just for the "designers"`}
        <ul parentName="li">
          <li parentName="ul">{`rewards - ownership, profit, credit, visibility`}</li>
        </ul>
      </li>
      <li parentName="ul">{`create community advisory boards or governing councils that can guide and own design process`}</li>
    </ul>
    <p>{`Values to build towards - Equity, Accountablity, Ownershipt`}</p>
    <h2>{`Chapter 3 : Design Narratives`}</h2>
    <p>{`Concerns :`}</p>
    <ul>
      <li parentName="ul">{`What story is told about design process?`}
        <ul parentName="li">
          <li parentName="ul">{`Who is attributed for the ideas?`}</li>
        </ul>
      </li>
      <li parentName="ul">{`What story do you tell about the problems?`}<br parentName="li"></br>
        {`Your reductive framing/scoping of the problem can skew solutions towards a direction.`}</li>
    </ul>
    <p>{`The contribution of "Communities of Practice" is invisiblized. Its picked up by others and called innovation of the individual`}</p>
    <h2>{`Chapter 4 : Design Sites`}</h2>
    <p>{`Where can this design process happen?`}</p>
    <h2>{`Chapter 5 : Design Pedagogies`}</h2>
    <p>{`Pop Education`}</p>
    <p>{`Inspirations :`}</p>
    <ul>
      <li parentName="ul">{`Paulo Friere`}</li>
      <li parentName="ul">{`Seymour Papert`}</li>
    </ul>
    <h1>{`Thoughts :`}</h1>
    <p>{`How do you reconcile the success of something like facebook, that was designed for an unmarked user doing so well in India and other non-western countries.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Design Justice helps us identify instances of generalized and pervasive processes by which existing design and tech processes systematically reproduce the matrix of domination.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      